import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { instagram, meta, x } from '../../assets'
import { AccountBalanceRounded, SchoolRounded } from '../../utils/constants'
import { WarningAmberRounded } from '@mui/icons-material'

import './terms.css'

type TabKey = 'tab1' | 'tab2' | 'tab3';
interface TabPositionParams {
  tab1: number
  tab2: number
  tab3: number
}

const Terms = () => {

  return (
    <>
      <title>Terms & Conditions</title>
      <div className="terms-section-wrapper">
        
      </div>
    </>
  )
}

export default Terms